import styled from "styled-components";

export const Icon = styled.div`
  width: 150px;
  height: 30px;
  background-size: contain;
  background-position: left center;
  background-repeat: no-repeat;
`;
